import ChartWidget from '../components/ChartWidget';
import GenericOptionsWidget from '../components/GenericOptionsWidget';

export default function Options() {
  return (
    <div>
      <ChartWidget />
      <GenericOptionsWidget />
    </div>
  );
}
